import { NotifyRepository } from 'application/repositories/NotifyRepository';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import { NotifyResponse, ParamsNotify, SettingNotifyData } from 'domain/entities/NotifyEntity';
export class NotifyUseCase implements NotifyUseCaseInterface {
    private notifyRepo: NotifyRepository;

    constructor(propertyRepo: NotifyRepository) {
        this.notifyRepo = propertyRepo;
    }

    async getCountNotify(): Promise<any> {
        return await this.notifyRepo.countUnreadNotify();
    }

    async getListNotifySystem(params: ParamsNotify): Promise<NotifyResponse> {
        return await this.notifyRepo.getListNotifySystem(params);
    }

    async getListNotify(params: ParamsNotify): Promise<NotifyResponse> {
        return await this.notifyRepo.getListNotify(params);
    }

    async updateSystemNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse> {
        return await this.notifyRepo.updateSystemNotice(params);
    }

    async updateOperationNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse> {
        return await this.notifyRepo.updateOperationNotice(params);
    }

    async settingNotifyForUser(notifyData: SettingNotifyData): Promise<PostPutDeleteBaseResponse> {
        return await this.notifyRepo.settingNotifyForUser(notifyData);
    }
}
export interface NotifyUseCaseInterface {
    getListNotifySystem(params: ParamsNotify): Promise<NotifyResponse>;
    getListNotify(params: ParamsNotify): Promise<any>;
    updateSystemNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse>;
    updateOperationNotice(params: { id: number }): Promise<PostPutDeleteBaseResponse>;
    settingNotifyForUser(notifyData: SettingNotifyData): Promise<PostPutDeleteBaseResponse>;
    getCountNotify(): Promise<NotifyResponse>;
}
